"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = __importDefault(require("axios"));
const configurations_1 = __importDefault(require("../config/configurations"));
class VindiGateway {
    constructor(environment, service) {
        this.authorizationHeader = () => `Basic ${Buffer.from(this.publicApiToken).toString('base64')}`;
        this.getGatewayToken = async (cardInformation) => {
            var _a, _b, _c;
            try {
                const instance = axios_1.default.create({
                    baseURL: this.url,
                    headers: {
                        authorization: this.authorizationHeader(),
                        'Content-Type': 'application/json',
                    },
                });
                const response = await instance.post('/v1/public/payment_profiles', {
                    holder_name: cardInformation.holderName,
                    card_number: cardInformation.cardNumber,
                    card_cvv: cardInformation.cardSecurityCode,
                    card_expiration: cardInformation.cardExpiration,
                    ...(cardInformation.cardBrand
                        ? {
                            payment_company_code: cardInformation.cardBrand,
                        }
                        : {}),
                });
                return response.data.payment_profile.gateway_token;
            }
            catch (exception) {
                if ((_b = (_a = exception === null || exception === void 0 ? void 0 : exception.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.errors) {
                    throw new Error((_c = exception.response.data.errors) === null || _c === void 0 ? void 0 : _c.map((error) => `${error.parameter} ${error.message}`).join('\n'));
                }
                throw exception;
            }
        };
        this.url = configurations_1.default[environment][service].url;
        this.publicApiToken = configurations_1.default[environment][service].publicApiToken;
    }
}
exports.default = VindiGateway;
